<script setup lang="ts">
    import { useSlots } from 'vue';

    interface Props {
        title: string;
        description: string;
    }

    defineProps<Props>();

    const slots = useSlots();
</script>
<template>
    <button
        class="h-34 w-56 max-w-full flex-grow overflow-hidden cursor-pointer text-left relative rounded-lg border"
    >
        <div v-if="slots.icon" aria-hidden="true" class="absolute top-4 right-4 w-5 h-5">
            <slot name="icon" />
        </div>
        <div class="absolute top-11.5 left-5 right-5">
            <span class="heading-sm block mb-1">{{ title }}</span>
            <span class="text-body text-gray-medium">{{ description }}</span>
        </div>
    </button>
</template>
